import { render, staticRenderFns } from "./MenusForm.vue?vue&type=template&id=b757f04a&scoped=true&"
import script from "./MenusForm.vue?vue&type=script&lang=js&"
export * from "./MenusForm.vue?vue&type=script&lang=js&"
import style0 from "./MenusForm.vue?vue&type=style&index=0&id=b757f04a&prod&lang=css&"
import style1 from "./MenusForm.vue?vue&type=style&index=1&id=b757f04a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b757f04a",
  null
  
)

export default component.exports